import { render, staticRenderFns } from "./DcFeaturedCourse.vue?vue&type=template&id=f03fc2a2&scoped=true&"
import script from "./DcFeaturedCourse.vue?vue&type=script&lang=ts&"
export * from "./DcFeaturedCourse.vue?vue&type=script&lang=ts&"
import style0 from "./DcFeaturedCourse.vue?vue&type=style&index=0&id=f03fc2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03fc2a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f03fc2a2', component.options)
    } else {
      api.reload('f03fc2a2', component.options)
    }
    module.hot.accept("./DcFeaturedCourse.vue?vue&type=template&id=f03fc2a2&scoped=true&", function () {
      api.rerender('f03fc2a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DcFeaturedCourse.vue"
export default component.exports